const events = [
  {
    id: 22,
    img: "/event-images/event-22.jpg",
    title: "LIFTOFF",
    date: "2nd April 2026",
    info: "A hands-on drone workshop where participants build their own drone and learn precision flying skills, offering a complete experience in drone technology and practical applications.",
    link: "https://example.com/register",
    open: true,
  },
  {
    id: 21,
    img: "/event-images/event-21.png",
    title: "EV-Unpugged",
    date: "30th January 2026",
    info: "EIC organizes EV Unplugged, a session introducing electric vehicle technology, e-mobility trends, and future opportunities in the EV domain",
    link: "https://example.com/register",
    open: true,
  },
  {
    id: 20,
    img: "/event-images/event-20.jpg",
    title: "APTIVERSE",
    date: "8 August 2025",
    info: "Gear up for placements with EIC’s Aptitude & Interview Skills Session! Master problem-solving, sharpen your reasoning, and learn the art of presenting yourself with confidence",
    open: true,
  },
  {
    id: 19,
    img: "/event-images/event-19.jpg",
    title: "Entrepreneurship Fest",
    date: "15th and 16th March 2025",
    info: "EIC’s Entrepreneurship Fest where innovators unleash their ideas, pitch their innovations, and compete to transform their vision into reality.",
    open: true,
  },
  {
    id: 18,
    img: "/event-images/event-18.jpg",
    title: "Secure IoT",
    date: "1st and 15th February 2025",
    info: "EIC brings you SECURE IoT, where innovation meets safety! Explore the world of connected devices, learn how to safeguard systems, and unlock the secrets of building a smarter, secure future.",
    open: true,
  },
  {
    id: 17,
    img: "/event-images/event-17.jpg",
    title: "The Book Odyssey",
    date: "28th January 2025",
    info: "EIC’s Book Reading Event, where ideas come alive, perspectives broaden, and every page opens a new door to imagination.",
    open: true,
  },
  {
    id: 16,
    img: "/event-images/event-16.png",
    title: "AI Alchemy",
    date: "24 January 2025",
    info: "EIC presents AI Workshop - where you can discover the power of intelligent systems, get hands-on with cutting-edge tools, and ignite your journey into the world of Artificial Intelligence.",
    open: true,
  },
    {
    id: 15,
    img: "/event-images/event-15.png",
    title: "IP Addressing",
    date: "10th August 2024",
    info: "Electro Infinity Club presents IP Addressing which contains a thorough informative session about Networking and IP Addressing.",
    link: "https://example.com/register",
    open: true,
  },
    {
    id: 14,
    img: "/event-images/event-14.png",
    title: "Fun Fair 2k24",
    date: "5th February 2024",
    info: "EIC presents Fun Fair 2k24, where your focus shines bright as you navigate the LED Memory, Buzz Wire, forging your path to triumph in the captivating Energy Path Puzzle game!",
    link: "https://example.com/register",
    open: true,
  },
    {
    id: 13,
    img: "/event-images/event-13.png",
    title: "IoT SYNERGIA",
    date: "14th, 15th, 21st October 2023",
    info: "Electro Infinity Club presents IOT SYNERGIA which contains Basic to Advance IOT Workshop & Hands on Raspberry PI.",
    link: "https://example.com/register",
    open: true,
  },
    {
    id: 12,
    img: "/event-images/event-12.jpg",
    title: "ELECTRO ESSENTIALS 3.0",
    date: "5th May 2023",
    info: "EIC has organised a event Electro Essentials 3.0. This event is about Basic Electronics Components and Hands-on exprience of Arduino UNO and Mini Project.",
    link: "https://example.com/register",
    open: true,
  },
    {
    id: 11,
    img: "/event-images/event-11.png",
    title: "PCB Workshop",
    date: "2nd February 2023",
    info: "Learn how to design PCB. Learn about PCB and its application in the industry. Hand-on PCB designing.",
    link: "https://example.com/register",
    open: true,
  },
    {
    id: 10,
    img: "/event-images/event-10.png",
    title: "Webinar on Raspberry PI",
    date: "7th January 2023",
    info: "Idea on how to build pbl & mini projects using Raspberry Pi. Learn about Raspberry pi and its applications in the  industry.",
    link: "https://example.com/register",
    open: true,
  },
    {
    id: 9,
    img: "/event-images/event-9.png",
    title: "ELECTRO ESSENTIALS 2.0",
    date: "2nd September 2022",
    info: "This event was second edition of Electro Essentials. Participants enjoyed hands on experience on Basic Electronic Components and Arduino UNO with some Mini Projects.",
    link: "https://example.com/register",
    open: true,
  },
    {
    id: 8,
    img: "/event-images/event-8.png",
    title: "Alumni Interaction With Students",
    date: "12th August 2022",
    info: "This event was organized to explain all about Data Science And AIML and various other courses needed to get good job placements.",
    link: "https://example.com/register",
    open: true,
  },
    {
    id: 7,
    img: "/event-images/event-7.png",
    title: "Workshop On Proteus Software",
    date: "12th April 2022",
    info: "This workshop is to provide knowledge regarding Proteus Software and covers every part regarding Printed Circuit Board.",
    link: "https://example.com/register",
    open: true,
  },
    {
    id: 6,
    img: "/event-images/event-6.png",
    title: "Rocket Boys Stream Party",
    date: "21st - 24th March 2022",
    info: "Electro Infinity Club presents live streaming of web series based on life of Dr. Homi Jehangir Bhabha and Dr. Vikram Ambalal Sarabhai, who created history while building India's future.",
    link: "https://example.com/register",
    open: true,
  },
    {
    id: 5,
    img: "/event-images/event-5.png",
    title: "Introduction to PCB Designing",
    date: "15th January 2022",
    info: "This workshop will cover the basics of PCB design, its terminologies, basics to schematic, footprint creation, placement & route and various other topics.",
    link: "https://example.com/register",
    open: true,
  },
    {
    id: 4,
    img: "/event-images/event-4.png",
    title: "Internet of Things and it's Applications",
    date: "10th December 2021",
    info: "This workshop will help you to learn and explore the internet of things, so don't miss this opportunity.",
    link: "https://example.com/register",
    open: true,
  },
    {
    id: 3,
    img: "/event-images/event-3.png",
    title: "Electronics Essential",
    date: "20th November 2021",
    info: "Students were given a practical hands-on session about basic components, breadboards, Arduino and connections and much more.",
    link: "https://example.com/register",
    open: true,
  },
    {
    id: 2,
    img: "/event-images/event-2.png",
    title: "EIC Quiz Series",
    date: "18th - 24th October 2021",
    info: "Online Quiz on questions related to basic electronics. Quiz took place for 6 days where students attempted over 30 questions",
    link: "https://example.com/register",
    open: true,
  },
    {
    id: 1,
    img: "/event-images/event-1.jpg",
    title: "Induction Program",
    date: "17th September 2021",
    info: "This Induction program was about brief information about the club and registration for new members.",
    link: "https://example.com/register",
    open: true,
  },
  
  
];

export default events;
